// Setup → Add digital employee (DE-WIZARD, review #12): `/c/{slug}/setup/des/new` is the one
// "Add digital employee" flow (managers; `?seat=` preselects a seat, the chart's "Fill with a
// DE"). It replaced "New digital employee" and "Deploy an agent" (`/setup/agents/deploy`
// redirects here, c.$slug.setup.agents.tsx). The DE list and profiles are in Agents
// (`/agents`, `/agents/de/{id}`); `/setup/des` and `/setup/des/{id}` redirect there
// (c.$slug.legacy.tsx). The static `new` segment wins over the legacy `$id`.
import { createRoute } from "@tanstack/react-router";
import { isManager } from "../features/company";
import { AddDeWizard } from "../features/de/add-de/add-de-wizard";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { NoAccessPage } from "../pages/status-pages";
import { setupRoute } from "./c.$slug.setup";

const UUID = /^[0-9a-f-]{36}$/i;

export const setupDeNewRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "des/new",
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(typeof search.seat === "string" && UUID.test(search.seat) ? { seat: search.seat } : {}),
    // TEMPLATES-T2: Templates' "Deploy" preselects the role template (its id).
    ...(typeof search.role === "string" && UUID.test(search.role) ? { role: search.role } : {}),
  }),
  component: function SetupDeNew() {
    const { api } = setupDeNewRoute.useRouteContext();
    const { seat, role } = setupDeNewRoute.useSearch();
    const company = useCompany();
    if (!isManager(company))
      return <NoAccessPage what="Adding a digital employee" slug={company.slug} />;
    return <AddDeWizard api={api} company={company} seat={seat} role={role} />;
  },
});
